import React from 'react';
import './Information.css';
import { Col, Row } from 'reactstrap';
import TutorialPosts from '../../layout/Tutorial/TutorialPosts';

const Information = props => {
    return (
        <div className="information row post-intro">
            <div className="d-flex flex-col">
                <Col className="information-welcome col-md-5 mr-3">
                    <h2 style={{ color: '#FA6D9E' }}>
                        Welcome <span>to your idea testing ground!</span>
                    </h2>
                    <p>
                        Filter the genius from the not-so-genius by getting your ideas in front of
                        industry professionals, colleagues and friends. If you feel you’ve got a
                        great answer, share it and you might get a donation. Go forth and create!
                    </p>
                </Col>
                <Col col-md-1 />
                <Col className="col-md-6 d-flex align-items-center">
                    <TutorialPosts />
                </Col>
            </div>
        </div>
    );
};

export default Information;
